export default __webpack_public_path__ + "eef3d37109c94f254e8a6ada5edfa554.png";